<div ngbDropdown placement="bottom-right" *ngIf="user$ | async as _user" class="kt-header__topbar-item kt-header__topbar-item--user">
	<div ngbDropdownToggle class="kt-header__topbar-wrapper">
		<div class="kt-header__topbar-user" [ngClass]="{'kt-header__topbar-icon': icon}">

			<!--
			* Temp user Profile
			* @author Rosa Korse
			* @since 2019-11-19
			*-->

			<span class="kt-header__topbar-welcome" *ngIf="isMobile || greeting">Hi,</span>
			<span class="kt-header__topbar-username " *ngIf="isMobile ||greeting">{{_user.firstname}}</span>
			<span *ngIf="!isMobile && badge" class="kt-badge kt-badge--username kt-badge--unified-success kt-badge--lg kt-badge--rounded kt-badge--bold">{{_user.firstname|firstLetter}}</span>

		</div>
	</div>
	<div ngbDropdownMenu class="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl">
		<!--begin: Head -->
		<div class="kt-user-card kt-user-card--skin-dark kt-notification-item-padding-x" style="background-image: url(./assets/media/misc/bg-1.jpg)">
			<div class="kt-user-card__avatar">
				<span [hidden]="false" class="kt-badge kt-badge--lg kt-badge--rounded kt-badge--bold kt-font-success">
					{{_user.firstname|firstLetter}}
				</span>
			</div>
			<div class="kt-user-card__name">
				{{_user.firstname}}
			</div>
		</div>
		<!--end: Head -->
		<!--begin: Navigation -->
		<div class="kt-notification">
			<div class="kt-notification__custom">
				<a href="javascript:;" routerLink="/userManagement/changePassword" class="btn btn-outline-brand btn-upper btn-sm btn-bold outbutton" style="margin-right: 10px" (click)="close()">Change Password</a>
				<a href="javascript:;" (click)="logout()" class="btn btn-outline-brand btn-upper btn-sm btn-bold outbutton">Sign Out</a>
			</div>
		</div>
		<!--end: Navigation -->
	</div>
</div>
